(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-product-customizer"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('lb-seat-customizer')) return;
  class LBSeatCustomizer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-config]');
      if (!data) return;
      this.ready = true;
      this.config = JSON.parse(data.textContent);
      this.q = s => this.querySelector(s);
      this.dialog = this.q('dialog');
      this.abort = new AbortController();
      this.initState();
      this.build();
      this.addEventListener('click', e => this.click(e), {signal: this.abort.signal});
      this.dialog.addEventListener('cancel', e => { if (this.busy) e.preventDefault(); }, {signal: this.abort.signal});
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.q('[data-launch]').focus({preventScroll: true});
      }, {signal: this.abort.signal});
      this.render();
      if (this.config.autoOpen && !this.config.designMode) this.open();
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.previousOverflow ?? ''; }
      this.ready = false;
    }
    initState() {
      this.seriesId = null; this.seats = null; this.layout = null; this.color = null; this.warrantyId = null;
      this.quantities = new Map(); this.activeStep = 0; this.openSteps = new Set([0]); this.busy = false; this.cartUncertain = false;
      this.notice = ''; this.imageRevision = 0;
      // ===== 解析贴纸锚点 JSON（新增）=====
      this.stickerAnchors = {};
      try {
        const raw = this.config.stickerAnchors;
        if (typeof raw === 'string' && raw.trim()) this.stickerAnchors = JSON.parse(raw);
        else if (raw && typeof raw === 'object') this.stickerAnchors = raw;
      } catch (e) { this.stickerAnchors = {}; }
      this.config.series.forEach(s => {
        s.options = Array.isArray(s.options) ? s.options : [];
        s.variants = Array.isArray(s.variants) ? s.variants : [];
        s.seatIndex = s.options.indexOf(s.seatOption);
        s.layoutIndex = s.options.indexOf(s.layoutOption);
        s.colorIndex = s.options.indexOf(s.colorOption);
        s.valid = !!s.productId && !s.requiresSellingPlan && s.variantCount <= 250 && s.variantCount === s.variants.length &&
          s.options.length === 3 && s.seatIndex >= 0 && s.layoutIndex >= 0 && s.colorIndex >= 0 &&
          new Set([s.seatIndex,s.layoutIndex,s.colorIndex]).size === 3;
      });
      [...this.config.features, ...this.config.warranties].forEach(a => {
        a.seriesIds = (a.seriesIds || '').split(',').map(x => x.trim()).filter(Boolean);
        a.compatibleIds = (a.compatibleIds || '').split(',').map(x => x.trim()).filter(Boolean);
      });
      this.config.warranties.forEach(w => {
        w.options = Array.isArray(w.options) ? w.options : [];
        w.variants = Array.isArray(w.variants) ? w.variants : [];
        w.durationIndex = w.options.indexOf(w.durationOption);
        w.seatIndex = w.options.indexOf(w.seatOption);
        w.valid = w.included || (!!w.productId && !w.requiresSellingPlan && w.variantCount <= 250 &&
          w.variantCount === w.variants.length && w.durationIndex >= 0 && w.seatIndex >= 0 &&
          w.durationIndex !== w.seatIndex && !!w.durationValue);
      });
      this.setupValid = this.config.series.length === 4 && this.config.series.every(s => s.valid) &&
        new Set(this.config.series.map(s => s.productId)).size === 4 && this.config.warranties.some(w => w.valid);
    }
    t(key, vars = {}) {
      let value = this.config.text[key] || key;
      Object.entries(vars).forEach(([k,v]) => { value = value.replaceAll('{' + k + '}', String(v)); });
      return value;
    }
    el(tag, cls, text) { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; }
    money(cents) { return new Intl.NumberFormat(this.config.locale || 'en', {style:'currency',currency:this.config.currency,currencyDisplay:'code'}).format(cents / 100); }
    series() { return this.config.series.find(s => s.id === this.seriesId); }
    usable(v) { return v.available && !v.requiresSellingPlan && v.min === 1 && v.increment === 1 && (v.max === null || v.max >= 1); }
    seatValue(v, s = this.series()) { const value = v.options[s.seatIndex]; return /^[1-6]$/.test(value) ? Number(value) : null; }
    candidates(seats = this.seats, layout = this.layout, s = this.series()) {
      return s?.valid ? s.variants.filter(v => this.usable(v) && this.seatValue(v,s) !== null &&
        (seats === null || this.seatValue(v,s) === seats) && (layout === null || v.options[s.layoutIndex] === layout)) : [];
    }
    variant() { return this.color === null ? null : this.candidates().find(v => v.options[this.series().colorIndex] === this.color); }
    compatible(a) {
      const s = this.series(), v = this.variant();
      return !!s && (!a.seriesIds.length || a.seriesIds.includes(String(s.productId))) &&
        (!a.compatibleIds.length || (!!v && a.compatibleIds.includes(String(v.id))));
    }
    purchasable(a) { return a.included || (!!a.variantId && a.available && a.min === 1 && a.increment === 1 && (a.max === null || a.max >= 1)); }
    warrantySeatValue(v,w) {
      const match = String(v?.options?.[w.seatIndex] || '').match(/\b([1-6])\b/);
      return match ? Number(match[1]) : null;
    }
    warrantyOption(w) {
      if (!w || !w.valid || !this.compatible(w) || !this.seats) return null;
      if (w.included) return {...w, variantId:null, price:0, available:true, min:1, increment:1, max:null};
      const v = w.variants.find(x => x.options[w.durationIndex] === w.durationValue && this.warrantySeatValue(x,w) === this.seats);
      if (!v || !this.usable(v)) return null;
      return {...w, variantId:v.id, price:v.price, available:v.available, min:v.min, increment:v.increment, max:v.max};
    }
    cap(a) {
      if (!this.seats || !this.compatible(a) || !this.purchasable(a)) return 0;
      return Math.max(0, Math.min(this.seats, a.max === null ? 6 : a.max, a.stock === null ? 6 : a.stock));
    }
    warranty() { return this.warrantyOption(this.config.warranties.find(w => w.id === this.warrantyId)); }
    selectedFeatures() { return this.config.features.filter(a => (this.quantities.get(a.id) || 0) > 0); }
    total() { return (this.variant()?.price || 0) + (this.warranty()?.price || 0) + this.selectedFeatures().reduce((n,a) => n + a.price * this.quantities.get(a.id), 0); }
    complete() { return this.setupValid && !!this.variant() && !!this.warranty(); }
    setSeries(id) {
      const s = this.config.series.find(x => x.id === id);
      if (!s || !s.valid || !this.candidates(null,null,s).length || id === this.seriesId) return;
      this.seriesId = id; this.seats = null; this.layout = null; this.color = null; this.warrantyId = null;
      this.quantities.clear(); this.notice = this.t('series_reset');
    }
    setSeats(count) {
      if (!Number.isInteger(count) || !this.candidates(count,null).length || count === this.seats) return;
      this.seats = count; this.layout = null; this.color = null;
      this.reconcile();
    }
    setLayout(layout) {
      if (!this.seats || !this.candidates(this.seats,layout).length || layout === this.layout) return;
      this.layout = layout; this.color = null; this.reconcile();
    }
    setColor(color) {
      if (!this.seats || !this.layout || !this.candidates().some(v => v.options[this.series().colorIndex] === color)) return;
      this.color = color; this.reconcile();
    }
    reconcile() {
      let changed = false;
      this.config.features.forEach(a => {
        const old = this.quantities.get(a.id) || 0, next = Math.min(old, this.cap(a));
        if (old !== next) changed = true;
        if (next) this.quantities.set(a.id,next); else this.quantities.delete(a.id);
      });
      if (this.warrantyId && !this.warranty()) { this.warrantyId = null; changed = true; }
      this.notice = changed ? this.t('adjusted') : '';
    }
    setQuantity(id, next) {
      const a = this.config.features.find(x => x.id === id);
      if (!a || !this.variant() || !Number.isInteger(next)) return;
      next = Math.max(0, Math.min(next, this.cap(a)));
      if (next) this.quantities.set(id,next); else this.quantities.delete(id);
    }
    setWarranty(id) {
      const w = this.config.warranties.find(x => x.id === id);
      if (this.variant() && this.warrantyOption(w)) this.warrantyId = id;
    }
    accessibleStep() { return !this.seriesId ? 0 : !this.seats ? 1 : !this.layout ? 2 : !this.variant() ? 3 : !this.warranty() ? 4 : 5; }
    build() {
      this.steps = ['series','seats','layout','color','warranty','features'].map((type,i) => {
        const root = this.el('div','lb-step'), h = this.el('h2','lb-step-heading');
        const toggle = this.el('button','lb-step-toggle'); toggle.type = 'button'; toggle.dataset.step = i;
        const label = this.config.titles[i], body = this.el('div','lb-step-body');
        const clip = this.el('div','lb-step-content'), content = this.el('div','lb-step-inner');
        body.id = `${this.id}-panel-${i}`; toggle.id = `${body.id}-toggle`;
        toggle.setAttribute('aria-controls',body.id); body.setAttribute('role','region'); body.setAttribute('aria-labelledby',toggle.id);
        toggle.append(this.el('span','',`${String(i+1).padStart(2,'0')}. ${label}`),this.el('span','lb-symbol','+'));
        clip.append(content); body.append(clip); h.append(toggle); root.append(h,body); this.q('[data-steps]').append(root);
return {type,body,content,toggle};
      });
    }
    visual(url, title) {
      const el = this.el('span','lb-choice-visual lb-product-thumb');
      if (url) { const img = this.el('img'); img.src = url; img.alt = ''; img.loading = 'lazy'; img.addEventListener('error',()=>{img.remove();el.textContent=title;},{once:true});el.append(img); }
      else el.append(this.el('span','lb-choice-textonly',title));
      return el;
    }
    choice(grid, kind, id, title, url, pressed, disabled, price) {
      const b = this.el('button','lb-choice'); b.type='button'; b.dataset[kind]=String(id);
      b.setAttribute('aria-pressed',String(pressed)); b.disabled = disabled || this.busy;
      b.append(this.visual(url,title),this.el('span','',title));
      if (price !== undefined) b.append(this.el('span','lb-addon-price',price)); grid.append(b); return b;
    }
    renderChoices() {
      const s=this.series(), v=this.variant();
      this.steps.forEach(step => {
        step.content.replaceChildren(); const grid=this.el('div','lb-choice-grid'); step.content.append(grid);
        if (step.type === 'series') {
          this.config.series.forEach(a=>this.choice(grid,'series',a.id,a.title,a.image,this.seriesId===a.id,!a.valid||!this.candidates(null,null,a).length));
        } else if (step.type === 'seats') {
          for (let n=1;n<=6;n++) {
            const example=this.candidates(n,null)[0];
            this.choice(grid,'seats',n,this.t('seat_count',{n}),example?.image,this.seats===n,!example);
          }
        } else if (step.type === 'layout') {
          if (!s || !this.seats) { grid.append(this.el('p','lb-hint',this.t('choose_previous'))); return; }
          const values=[...new Set(this.candidates(this.seats,null).map(a=>a.options[s.layoutIndex]))];
          values.forEach(layout=>{const example=this.candidates(this.seats,layout)[0];this.choice(grid,'layout',layout,layout,example?.image,this.layout===layout,false);});
        } else if (step.type === 'color') {
          if (!s || !this.seats || !this.layout) { grid.append(this.el('p','lb-hint',this.t('choose_previous'))); return; }
          const values=[...new Set(this.candidates().map(a=>a.options[s.colorIndex]))];
          values.forEach(color=>{const example=this.candidates().find(a=>a.options[s.colorIndex]===color);this.choice(grid,'color',color,color,example.image,this.color===color,false);});
        } else if (step.type === 'warranty') {
          const options=this.config.warranties.filter(a=>this.compatible(a));
          options.forEach(a=>{const resolved=this.warrantyOption(a);this.choice(grid,'warranty',a.id,a.title,a.image,this.warrantyId===a.id,!v||!resolved,a.included?this.t('included'):(resolved?`+ ${this.money(resolved.price)}`:''));});
          if (!options.some(a=>this.warrantyOption(a))) step.content.append(this.el('p','lb-hint',this.t('no_warranty')));
        } else {
          grid.classList.add('lb-feature-grid');
          step.content.prepend(this.el('p','lb-hint',this.t('feature_hint',{n:this.seats||0})));
          const options=this.config.features.filter(a=>this.compatible(a));
          options.forEach(a=>{
            const card=this.el('div','lb-feature-card'), qty=this.quantities.get(a.id)||0, cap=this.cap(a);
            this.choice(card,'feature',a.id,a.title,a.image,qty>0,!v||!cap,`${this.money(a.price)} ${this.t('per_seat')}`);
            const controls=this.el('div','lb-quantity'); controls.setAttribute('role','group'); controls.setAttribute('aria-label',a.title);
            const minus=this.el('button','', '−'), plus=this.el('button','', '+'), out=this.el('output','',String(qty));
            minus.type=plus.type='button'; minus.dataset.minus=plus.dataset.plus=a.id;
            minus.setAttribute('aria-label',this.t('decrease',{name:a.title})); plus.setAttribute('aria-label',this.t('increase',{name:a.title}));
            out.setAttribute('aria-label',this.t('installed_seats')); out.setAttribute('aria-live','polite');
            minus.disabled=this.busy||qty===0;plus.disabled=this.busy||!v||qty>=cap;
            controls.append(minus,out,plus);card.append(controls,this.el('small','lb-feature-subtotal',`${qty} / ${this.seats||0} · ${this.money(a.price*qty)}`));
            if (qty && a.description) card.append(this.el('p','lb-feature-description',a.description));
            if (!cap) card.append(this.el('small','',this.t('unavailable')));
            grid.append(card);
          });
          if (!options.length) step.content.append(this.el('p','lb-hint',this.t('no_features')));
          const review=this.el('dl','lb-review');
          const row=(key,val)=>{const d=this.el('div','lb-review-row');d.append(this.el('dt','',key),this.el('dd','',val));review.append(d);};
          if (s) row(this.config.titles[0],s.title);
          if (this.seats) row(this.config.titles[1],String(this.seats));
          if (this.layout) row(this.config.titles[2],this.layout);
          if (this.color) row(this.config.titles[3],this.color);
          if (this.warranty()) row(this.config.titles[4],this.warranty().title);
          this.selectedFeatures().forEach(a=>row(`${a.title} × ${this.quantities.get(a.id)}`,this.money(a.price*this.quantities.get(a.id))));
          step.content.append(review,this.el('p','lb-review-total',`${this.t('subtotal')}: ${this.money(this.total())}`),this.el('p','lb-price-note',this.config.priceNote));
        }
      });
    }
    focusKey() {
      const b=document.activeElement;
      if (!b || !this.contains(b)) return null;
      for (const key of ['series','seats','layout','color','warranty','feature','minus','plus']) if (b.dataset[key] !== undefined) return {key,value:b.dataset[key]};
      return null;
    }
    render() {
      const focus=this.focusKey(), host=this.q('[data-steps]'), scroll=host.scrollTop;
      this.renderChoices();
      const accessible=this.accessibleStep();
this.activeStep=Math.min(this.activeStep,accessible);
this.openSteps=new Set([...this.openSteps].filter(i=>i<=accessible));
this.steps.forEach((s,i)=>{
  const open=this.openSteps.has(i);
  s.body.classList.toggle('is-open',open);
  s.body.setAttribute('aria-hidden',String(!open));
  s.body.inert=!open;
  s.toggle.disabled=this.busy||i>accessible;
  s.toggle.setAttribute('aria-expanded',String(open));
  s.toggle.querySelector('.lb-symbol').textContent=open?'−':'+';
});
      this.q('[data-prev]').disabled=this.busy||this.activeStep===0;
      this.q('[data-next]').disabled=this.busy||this.activeStep===5||this.activeStep>=this.accessibleStep();
      this.q('[data-progress]').textContent=`${this.activeStep+1}/6`;
      const s=this.series(), v=this.variant();
      this.q('[data-product-title]').textContent=s?.title||this.config.title;
      const summary=[s?.title,this.seats?this.t('seat_count',{n:this.seats}):'',this.layout,this.color,this.warranty()?.title].filter(Boolean).join(' / ');
      this.q('[data-configuration]').textContent=summary;
      this.q('[data-preview-caption]').textContent=summary;
      this.q('[data-total]').textContent=v?this.money(this.total()):this.t('choose_price');
      const add=this.q('[data-add]');add.disabled=this.busy||this.cartUncertain||!this.complete()||this.activeStep!==5;add.textContent=this.busy?this.t('adding'):this.config.addLabel;
      this.q('[data-close]').disabled=this.busy;this.q('.lb-panel').setAttribute('aria-busy',String(this.busy));
      const notice=this.q('[data-notice]');notice.hidden=!this.notice;notice.textContent=this.notice;
      const setup=this.q('[data-setup]');setup.hidden=this.setupValid;setup.textContent=this.config.designMode?this.t('setup_admin'):this.t('setup_customer');
      this.renderPreview();
      this.renderStickers();
      host.scrollTop=scroll;
      if (focus) {
        const button=Array.from(this.querySelectorAll(`[data-${focus.key}]`)).find(b=>b.dataset[focus.key]===focus.value);
        if (button && !button.disabled) button.focus({preventScroll:true});
        else this.steps[this.activeStep].toggle.focus({preventScroll:true});
      }
    }
    renderPreview() {
      const s=this.series(), v=this.variant();
      const example=v||(this.seats?this.candidates(this.seats,this.layout)[0]:null);
      const url=example?.image||s?.image||this.config.baseImage;
      if (url===this.previewUrl) return;
      this.previewUrl=url;const rev=++this.imageRevision, stage=this.q('[data-stage]'), error=this.q('[data-preview-error]');
      stage.replaceChildren();error.hidden=true;
      if (!url) {error.hidden=false;return;}
      stage.setAttribute('aria-busy','true');
      const img=this.el('img');img.alt=[s?.title,example?.options.join(' / ')].filter(Boolean).join(' · ');
      img.onload=()=>{if(rev===this.imageRevision){stage.replaceChildren(img);stage.setAttribute('aria-busy','false');this.renderStickers();}};
      img.onerror=()=>{if(rev===this.imageRevision){error.hidden=false;stage.setAttribute('aria-busy','false');}};
      img.src=url;
    }
    /* ===== 新增：渲染贴纸标注（用功能图本身当贴纸）===== */
    renderStickers() {
      const stage = this.q('[data-stage]');
      stage.querySelectorAll('.lb-sticker').forEach(el => el.remove());
      if (!this.seats) return;
      // 取座位锚点：优先按系列名称查，再按 layout 细分，最后回退到全局
      const s = this.series();
      const seriesKey = s?.title || 'default';
      const seatsKey = String(this.seats);
      const layoutKey = this.layout || 'default';
      let seatAnchors = null;
      if (this.stickerAnchors[seriesKey]?.[layoutKey]?.[seatsKey]) {
        seatAnchors = this.stickerAnchors[seriesKey][layoutKey][seatsKey];
      } else if (Array.isArray(this.stickerAnchors[seriesKey]?.[seatsKey])) {
        seatAnchors = this.stickerAnchors[seriesKey][seatsKey];
      } else if (Array.isArray(this.stickerAnchors[seatsKey])) {
        seatAnchors = this.stickerAnchors[seatsKey];
      } else if (Array.isArray(this.stickerAnchors.default?.[seatsKey])) {
        seatAnchors = this.stickerAnchors.default[seatsKey];
      }
      // 功能单独配置
      const featOverrides = this.stickerAnchors[seriesKey]?.features || {};
      if (!seatAnchors && !Object.keys(featOverrides).length) return;
      // 4 个功能循环用色（仅用于底部小圆点区分）
      const palette = ['#ef4444','#f59e0b','#10b981','#6366f1','#ec4899','#06b6d4','#8b5cf6','#14b8a6'];
      this.config.features.forEach((f, fi) => {
        const qty = this.quantities.get(f.id) || 0;
        if (!qty || !f.image) return;
        const color = palette[fi % palette.length];
        const ov = featOverrides[f.title];
        if (ov && typeof ov.x === 'number') {
          // 单次标识模式：只放一个
          this.appendSticker(stage, f.image, f.title, ov, color);
        } else if (Array.isArray(ov)) {
          for (let i = 0; i < qty && i < ov.length; i++) {
            this.appendSticker(stage, f.image, f.title, ov[i], color);
          }
        } else if (seatAnchors) {
          for (let i = 0; i < qty && i < seatAnchors.length; i++) {
            this.appendSticker(stage, f.image, f.title, seatAnchors[i], color);
          }
        }
      });
    }
    appendSticker(stage, src, alt, p, color) {
      const st = this.el('div','lb-sticker');
      st.style.left = p.x + '%';
      st.style.top  = p.y + '%';
      st.style.transform = `translate(-50%, -100%) rotate(${p.rot||0}deg) skewX(${p.skX||0}deg) skewY(${p.skY||0}deg)`;
      const img = this.el('img');
      img.src = src; img.alt = alt; img.loading = 'lazy';
      img.style.width = (p.w || 110) + 'px';
      img.style.height = (p.h || p.w || 110) + 'px';
      const dot = this.el('div','lb-sticker-dot');
      dot.style.background = color;
      st.append(img, dot);
      stage.appendChild(st);
    }
    open() {if(this.dialog.open)return;this.previousOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';this.q('[data-close]').focus({preventScroll:true});}
    click(event) {
      const b=event.target.closest('button');if(!b||!this.contains(b)||b.disabled)return;
      if(b.hasAttribute('data-launch'))return this.open();if(this.busy)return;
      if(b.hasAttribute('data-close'))return this.dialog.close();
      if(b.hasAttribute('data-add'))return this.addToCart();
      let navigation=false;
      if(b.dataset.step!==undefined){
  const target=Math.min(Number(b.dataset.step),this.accessibleStep());
  this.activeStep=target;
  if(this.openSteps.has(target)){
    this.openSteps.delete(target);
  }else{
    this.openSteps.add(target);
  }
  navigation=true;
}
else if(b.hasAttribute('data-prev')){
  this.activeStep=Math.max(0,this.activeStep-1);
  this.openSteps.add(this.activeStep);
  navigation=true;
}
else if(b.hasAttribute('data-next')){
  this.activeStep=Math.min(5,this.accessibleStep(),this.activeStep+1);
  this.openSteps.add(this.activeStep);
  navigation=true;
}
      else if(b.dataset.series!==undefined)this.setSeries(b.dataset.series);
      else if(b.dataset.seats!==undefined)this.setSeats(Number(b.dataset.seats));
      else if(b.dataset.layout!==undefined)this.setLayout(b.dataset.layout);
      else if(b.dataset.color!==undefined)this.setColor(b.dataset.color);
      else if(b.dataset.warranty!==undefined)this.setWarranty(b.dataset.warranty);
      else if(b.dataset.feature!==undefined)this.setQuantity(b.dataset.feature,this.quantities.get(b.dataset.feature)?0:1);
      else if(b.dataset.plus!==undefined)this.setQuantity(b.dataset.plus,(this.quantities.get(b.dataset.plus)||0)+1);
      else if(b.dataset.minus!==undefined)this.setQuantity(b.dataset.minus,(this.quantities.get(b.dataset.minus)||0)-1);
            const selectedStep = [
        'series',
        'seats',
        'layout',
        'color',
        'warranty'
      ].findIndex(key => b.dataset[key] !== undefined);

      if (selectedStep !== -1) {
        const nextStep = Math.min(
          selectedStep + 1,
          this.accessibleStep()
        );

        this.openSteps.add(selectedStep);
        this.openSteps.add(nextStep);
        this.activeStep = nextStep;
        navigation = true;
      }

      this.render();
    }

    cartItems() {
      if(!this.complete())throw new Error(this.t('choose_previous'));
      for(const a of this.selectedFeatures()){const n=this.quantities.get(a.id);if(!Number.isInteger(n)||n<1||n>this.cap(a))throw new Error(this.t('adjusted'));}
      const group=globalThis.crypto?.randomUUID?.()||`lb-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const props={_lb_configuration:group,Series:this.series().title,'Seat count':String(this.seats),Layout:this.layout,Color:this.color,Warranty:this.warranty().title};
      const features=this.selectedFeatures();if(features.length)props['Installed features']=features.map(a=>`${a.title} × ${this.quantities.get(a.id)} ${this.t('seats_word')}`).join('; ');
      const items=[{id:this.variant().id,quantity:1,properties:props}];
      if(!this.warranty().included)items.push({id:this.warranty().variantId,quantity:1,properties:{_lb_configuration:group,'For series':this.series().title,Warranty:this.warranty().title,'Seat count':String(this.seats)}});
      features.forEach(a=>items.push({id:a.variantId,quantity:this.quantities.get(a.id),properties:{_lb_configuration:group,'For series':this.series().title,Feature:a.title,'Total seats':String(this.seats)}}));
      return items;
    }
    async addToCart() {
      if(this.busy||this.cartUncertain||!this.complete()||this.activeStep!==5)return;
      let items;try{items=this.cartItems();}catch(e){this.notice=e.message;this.render();return;}
      this.busy=true;this.q('[data-error]').hidden=true;this.q('[data-cart-link]').hidden=true;this.render();
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
      try{
        const response=await fetch(this.config.cartAddUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:controller.signal});
        const result=await response.json();if(!response.ok||result.status)throw new Error(typeof result.description==='string'?result.description:this.t('cart_failed'));
        window.location.assign(this.config.cartUrl);
      }catch(e){this.cartUncertain=true;const error=this.q('[data-error]');error.hidden=false;error.textContent=(e.name==='AbortError'?this.t('timeout'):e.message)+' '+this.t('check_before_retry');this.q('[data-cart-link]').hidden=false;}
      finally{clearTimeout(timer);this.busy=false;this.render();}
    }
  }
  customElements.define('lb-seat-customizer',LBSeatCustomizer);
})();


  } catch(e) { console.error(e); }
})();
})();
